import { render, staticRenderFns } from "./NavBarV.vue?vue&type=template&id=f642552c"
import script from "./NavBarV.vue?vue&type=script&lang=js"
export * from "./NavBarV.vue?vue&type=script&lang=js"
import style0 from "./NavBarV.vue?vue&type=style&index=0&id=f642552c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports